// D-255 - "[שם] עובדת על זה": the pure part (names, time, gender-neutral wording keys).
// The server sends the employees whose timer is running on the ticket: OTE gets name + start time,
// the portal gets the display name only.

export interface WorkingNowItem {
  name: string;
  since?: string;
}

/** Keeps only usable entries (a name), de-duplicated by name, in the server's order. */
export function cleanWorkingNow(raw: unknown): WorkingNowItem[] {
  if (!Array.isArray(raw)) return [];
  const seen = new Set<string>();
  const out: WorkingNowItem[] = [];
  for (const x of raw) {
    const name = x && typeof (x as WorkingNowItem).name === 'string' ? (x as WorkingNowItem).name.trim() : '';
    if (!name || seen.has(name)) continue;
    seen.add(name);
    const since = (x as WorkingNowItem).since;
    out.push(typeof since === 'string' && since ? { name, since } : { name });
  }
  return out;
}

/** "רחל", "רחל ולאה", "רחל, לאה ומיכל". */
export function joinNames(names: string[], lang: string): string {
  if (names.length <= 1) return names[0] ?? '';
  try {
    const LF = (Intl as unknown as { ListFormat: new (l: string, o: object) => { format(v: string[]): string } }).ListFormat;
    return new LF(lang || 'he', { style: 'long', type: 'conjunction' }).format(names);
  } catch {
    return `${names.slice(0, -1).join(', ')} ${names[names.length - 1]}`;
  }
}

/** The earliest start, as HH:MM, or '' when unknown (portal / no time). */
export function sinceLabel(items: WorkingNowItem[], lang: string): string {
  const times = items.map((i) => (i.since ? new Date(i.since).getTime() : NaN)).filter((n) => Number.isFinite(n));
  if (times.length === 0) return '';
  return new Intl.DateTimeFormat(lang || 'he', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(Math.min(...times)));
}
